import React, { useEffect, useRef, useState } from 'react';
import Icon from '../ui/Icon';

export type Command = {
  grp: string;
  id: string;
  label: string;
  icon: string;
  kbd?: string;
  action?: boolean;
};

type Props = {
  commands: Command[];
  onClose: () => void;
  onNav: (id: string) => void;
  onAction: (id: string) => void;
};

export default function CommandPalette({ commands, onClose, onNav, onAction }: Props) {
  const [q, setQ] = useState('');
  const [sel, setSel] = useState(0);
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => { inputRef.current?.focus(); }, []);

  const filtered = commands.filter((c) => !q || c.label.toLowerCase().includes(q.toLowerCase()));
  useEffect(() => { setSel(0); }, [q]);

  function run(c?: Command) {
    if (!c) return;
    if (c.action) onAction(c.id); else onNav(c.id);
    onClose();
  }
  function onKey(e: React.KeyboardEvent) {
    if (e.key === 'ArrowDown') { e.preventDefault(); setSel((s) => Math.min(s + 1, filtered.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setSel((s) => Math.max(s - 1, 0)); }
    else if (e.key === 'Enter') { e.preventDefault(); run(filtered[sel]); }
    else if (e.key === 'Escape') { onClose(); }
  }

  let lastGrp: string | null = null;
  return (
    <div className="cmdk-scrim" onClick={onClose}>
      <div className="cmdk" onClick={(e) => e.stopPropagation()}>
        <div className="cmdk-input">
          <Icon name="search" size={19} />
          <input ref={inputRef} value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={onKey} placeholder="Szukaj sekcji lub akcji…" />
          <span className="kbd" style={{ color: 'var(--fg-3)', fontFamily: 'var(--font-mono)', fontSize: 11, padding: '3px 7px', borderRadius: 6, background: 'var(--surface-3)' }}>ESC</span>
        </div>
        <div className="cmdk-list">
          {filtered.length === 0 && <div className="cmdk-grp">Brak wyników</div>}
          {filtered.map((c, i) => {
            const showGrp = c.grp !== lastGrp;
            lastGrp = c.grp;
            return (
              <React.Fragment key={c.id}>
                {showGrp && <div className="cmdk-grp">{c.grp}</div>}
                <div className={`cmdk-item ${i === sel ? 'sel' : ''}`} onMouseEnter={() => setSel(i)} onClick={() => run(c)}>
                  <div className="ci"><Icon name={c.icon} size={16} /></div>
                  {c.label}
                  {c.kbd && <span className="ck">{c.kbd}</span>}
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
}
